whenAvailable('$', function() {
$(function() {

    const getOldSku = function(currentSku) {
        var sku_2024 = currentSku;
        if(store_code == 'UK'){
            sku_2024 = sku_2024.replace('3S','1S').replace('3R','1R').replace('3X','1X');
        }
        var sku_index = titan_evo_2024.indexOf(sku_2024);
        if(sku_index != -1){
            return targetVariantSku = titan_evo_2022[sku_index];
        }else{
            return sku_2024;
        }
    }
    const getEvoLiteSku = function(currentSku) {
        if(store_code == 'UK'){
            return currentSku?.replace('EL3','EL1');
        }
        return currentSku;
    }
    whenAvailable('slick', function() {
        // -- PRODUCT SUBIMAGES -- //
        // TOGGLE SUBIMAGES AND CONTENT RELEVANT TO SELECTED SKU
        $.productDisplay = function() {}

        $.productDisplay.generateSubimages = function(container) {
            if (container == undefined) { container = '#productGeneric'; }

            if(!pdt_subimages) {
                return;
            }
            Object.keys(pdt_subimages).forEach(function(sku, i) {
                imgs = pdt_subimages[sku].replace(/ /g, '').split(',');
                imgs.forEach(function(v, i) {

                    var url = 'https://images.secretlab.co/subimage/tr:n-display_gallery/' + v;
                    var thumb = 'https://images.secretlab.co/subimage/tr:n-display_thumbnail/' + v;
                    var subImageDisplay =  $(container + ' .product-display .subimages');
                    var altText = sku;
                    var currentPageHandle = $('[data-page-handle]').data('page-handle');
                    if(currentPageHandle.includes('magnus-pro')){
                        altText = 'Secretlab MAGNUS Pro Standing Desk'
                        if(i == imgs.length - 1){
                            altText = "top view of the Secretlab MAGNUS Pro Standing Desk"
                        }
                    }

                    subImageDisplay.prepend('<a href="' + url + '" class="obj popup-image" data-sku="' + sku + '"><img src="' + pdt_subimages_placeholder + '" data-src="' + thumb + '" class="lazy lazy-fade" alt="' + altText + '"></a>')

                    if(pdt_videos && i === imgs.length - 1) {
                        subImageDisplay.prepend('<a href="' + pdt_videos[sku][0] + '" class="obj popup-youtube" data-sku="' + sku + '"><div class="play-video-icon within-subimage"><i class="fas fa-play-circle"></i></div><img src="' + pdt_subimages_placeholder + '" data-src="' + pdt_videos[sku][1] + '" class="lazy lazy-fade"></a>')
                    }
                });

                if ( pdt_gallery_videos[sku] ) {
                    pdt_gallery_videos[sku].forEach((video, vi) => {
                        let subImageDisplay =  $(container + ' .product-display .subimages');
                        let vidsrc = `<source src="${video['webm']}"><source src="${video['mp4']}">`;
                        let vidhtml = `<video class="pswp__img start-0 end-0 bottom-0 m-auto w-50" muted autoplay loop controls controlsList="nodownload" preload="none" playsinline="true" poster="${video['poster']}">${vidsrc}</video>`
                        let vidhtml_thumbs = `<video class="w-100 h-auto" muted autoplay loop poster="${video['poster']}">${vidsrc}</video>`
                        subImageDisplay.prepend(`<a href="#" class="obj popup-image" data-sku="${sku}" data-popuptype="video" data-video-src='${vidhtml}'>
                        ${vidhtml_thumbs}</a>`)
                    });
                }

                if ( i == Object.keys(pdt_subimages).length-1 ) {
                    whenAvailable('lazyload', function() { initLazyload(); });
                    setTimeout(function(){ $.productDisplay.updateProductDisplay(container); }, 200)
                }
            });
        };

        $.productDisplay.updateProductDisplay = function(container) {
            if (container == undefined) { container = '#productGeneric'; }

            $(container + ' [data-sku-content]').hide();
            $(container + ' .product-display .subimages .obj').removeClass('active');

            if (container == '#productModal') {
                let variant_handle = $('#productModalInfo').attr('data-product-handle'),
                    variant_sku = $('#productModalInfo').attr('data-sku'),
                    magrgbv2_skus = ['Mag-RGB15A-v2', 'Mag-RGB15C-v2', 'Mag-RGB15G-v2'];

                // Overwrite variant_handle for magrgba-v2 SKUs as default is desk handle instead of magrgb handle
                if ($.inArray(variant_sku, magrgbv2_skus) !== -1) { variant_handle = 'magrgb-diffused-rgb-strip-v2'; }

                $('#productModal .product-display .subimages .obj[data-sku="' + variant_handle + '"], #productModal .product-display .subimages .obj[data-sku="' + variant_sku + '"]').addClass('active');
                $('#productModal [data-sku-content*="/'+ variant_sku +'/"]').show();
            } else {
                $(container + ' .atc-item-variant.active').each(function(i, v) {
                    var data_sku = $(v).attr('data-sku');
                    if (data_sku.includes('E24')) {
                        data_sku = getOldSku(data_sku);
                    }else if(Boolean(data_sku.match(/EL(1|3)(PU|SW)/))){
                        data_sku = getEvoLiteSku(data_sku);
                    }
                    $(container + ' .product-display .subimages .obj[data-sku="' + $(v).attr('data-product-handle') + '"]').addClass('active');
                    $(container + ' .product-display .subimages .obj[data-sku="' + $(v).attr('data-sku-handle') + '"]').addClass('active');
                    $(container + ' .product-display .subimages .obj[data-sku="' + data_sku + '"]').addClass('active');
                    $(container + ' [data-sku-content*="/'+  $(v).attr('data-sku') +'/"]').show();
                });

                if ( $(container + ' .atc-item-variant').length == 0 ) {
                    $(container + ' .product-display .subimages .obj').addClass('active');
                }

                // set manual SKU when on load
                if(override_subimage_sku) {
                    // remove class for all subimages
                    $(container + ' .product-display .subimages .obj').removeClass('active');
                    // add active class to specific SKU
                    $(container + ' .product-display .subimages .obj[data-sku="' + override_subimage_sku + '"]').addClass('active');
                }

                // set count of how many video(s) will be display
                if(no_pdt_videos_showing) {
                    const videoElement = $(container + ' .product-display .subimages .obj.popup-youtube')

                    videoElement.each(function(i, v) {
                        if(i >= no_pdt_videos_showing) {
                            v.remove()
                        }
                    });
                }
            }

            initSubimagesSlick(container);
        }

        // INITIALIZE SUBIMAGE SLICK
        function initSubimagesSlick(container) {
            if (container == undefined) { container = '#productGeneric'; }

            if (!isMobile && $(document).width() < 992 || $(document).width() >= 992) {
                if ( !$(container + ' .product-display .subimages').hasClass('slick-initialized') ) {
                    $(container + ' .product-display .subimages')?.slick({
                        slide: '.active',
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        mobileFirst: true,
                        prevArrow: '<div class="arrow-prev"><svg class="svg-inline--fa fa-chevron-left fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg></div>',
                        nextArrow: '<div class="arrow-next"><svg class="svg-inline--fa fa-chevron-right fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg></div>',
                        responsive: [
                            { breakpoint: 424, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            { breakpoint: 566, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                            { breakpoint: 767, settings: { slidesToShow: 6, slidesToScroll: 6 } },
                            { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 4 } }
                        ]
                    });
                    $(container + ' .product-display.vertical .subimages')?.slick('slickSetOption', {
                        responsive: [
                            { breakpoint: 424, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            { breakpoint: 566, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                            { breakpoint: 767, settings: { slidesToShow: 6, slidesToScroll: 6 } },
                            { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            { breakpoint: 1899, settings: { slidesToShow: 4, slidesToScroll: 4, vertical: true, verticalSwiping: true, prevArrow: '<div class="arrow-prev"><svg class="svg-inline--fa fa-chevron-up fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"></path></svg></div>', nextArrow: '<div class="arrow-next"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>' } }
                        ]
                    }, true);

                    // Minor variation if product has video
                    if ($('.accessory-video').length) {
                        $(container + ' .product-display.horizontal .subimages')?.slick('slickSetOption', {
                            responsive: [
                                { breakpoint: 424, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                                { breakpoint: 566, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                                { breakpoint: 767, settings: { slidesToShow: 6, slidesToScroll: 6 } },
                                { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                                { breakpoint: 1899, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            ]
                        }, true);
                    }
                    if ($('.product-display-video').length) {
                        $(container + ' .product-display.vertical .subimages')?.slick('slickSetOption', {
                            responsive: [
                                { breakpoint: 424, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                                { breakpoint: 566, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                                { breakpoint: 767, settings: { slidesToShow: 6, slidesToScroll: 6 } },
                                { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                                { breakpoint: 1899, settings: { slidesToShow: 4, slidesToScroll: 4, vertical: true, verticalSwiping: true, prevArrow: '<div class="arrow-prev"><svg class="svg-inline--fa fa-chevron-up fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"></path></svg></div>', nextArrow: '<div class="arrow-next"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>' } }
                            ]
                        }, true);
                    }
                } else {
                    $(container + ' .product-display .subimages')?.slick('refresh');
                }
            } else if ( $(container + ' .product-display .subimages').hasClass('slick-initialized') ) {
                $(container + ' .product-display .subimages')?.slick('unslick');
            }
        }
        initSubimagesSlick();
        $(window).resize(function() { initSubimagesSlick(); });

        // INITIALIZE EVENTS ON PAGE LOAD
        if (typeof pdt_subimages !== 'undefined' && pdt_subimages !== '') {
            $.productDisplay.generateSubimages();
        }

        // -- PRODUCT PARTNER LOGO --//
        // Display official partner logo if it exists
        function displayPartnerLogo() {
            if(!partner_logo) {
                return;
            }

            let curr_sku = document.querySelector('[data-atc-id]:not(.atc-item-variant)').dataset.sku.toLowerCase(),
                suffix_sku = curr_sku.replace('m06-', '').replace('m07-', '').replace('m08-', '')
                  .replace('1r', '').replace('1s', '').replace('1x', '')
                  .replace('3r', '').replace('3s', '').replace('3x', '')
                  .split('-').pop(),
                act_img = partner_imgs.filter(el => el.dataset.sku.toLowerCase().split(/(\s+)/).includes(suffix_sku)).pop(),
                prev_img = partner_logo.querySelector('img.active');
                
                if(act_img) {
                    if(prev_img && !prev_img.isEqualNode(act_img))
                        prev_img.classList.remove('active');

                    act_img.classList.add('active');
                    partner_logo.classList.add('active');
                }
        }

        // -- PRODUCT IMAGE SELECTORS --//
        // If product page does not use canvas turntable
        function toggleSKUImg() {
            var getSKU = $(this).attr('data-sku');
            var $obj = !$('#canvas-container').length ? $('.product-display') : $(this);
            $obj.find('[data-img-sku]').hide();
            $obj.find('[data-img-sku="' + getSKU + '"]').show();
        }

        $('[data-atc-id]').each(toggleSKUImg);
        $('[data-atc-id]').on('skuchange', toggleSKUImg);

        // -- PRODUCT TURNTABLE -- //
        // Canvas Elements
        var container = document.getElementById('canvas-container');
        if (container != undefined) {
            var canvas =  document.getElementById('canvasTurntable');
            var ctx = canvas.getContext('2d');

            // JQuery Elements
            var $canvas = $('#canvasTurntable');
            var $paging = $('.canvas-turntable-paging');

            var canvas_turntable = document.querySelector('.canvas-turntable');
            var partner_logo = document.querySelector('#partnerLogo');
            var partner_imgs = partner_logo ? Array.from(partner_logo.querySelectorAll("img")) : [];

            partner_imgs.forEach(el => el.dataset.sku = el.dataset.sku.toLowerCase());

            const showPartnerLogo = () => partner_logo.classList.remove('logo-hidden');
            const hidePartnerLogo = () => partner_logo.classList.add('logo-hidden');

            if (canvas_turntable && partner_logo) {
                if(isMobile) {
                    canvas_turntable.addEventListener('touchmove', () => {
                        if(imgIndex !== 1) hidePartnerLogo();
                        else showPartnerLogo();
                    });
                }
                else {
                    canvas_turntable.addEventListener('mouseleave', showPartnerLogo);
                    canvas_turntable.addEventListener('mouseenter', hidePartnerLogo);
                }
            }

            // Global Variables
            var selectedSKU = '';
            var selectedSkuTheme = '';
            var imgIndex = 1;
            var currIndex = 1;
            var zoom = 2;
            var layers = [];
            var hRatio, vRatio, ratio, ratioScale;
            var isInit = true;
            var renderTimeout;
            var loopCheck = true;

            // Pokemon Copyright
            var pokemonLayer = new Image();
            pokemonLayer.src = `https://images.secretlab.co/theme/common/collab_pokemon_copyright-min.png`;

            // 2022 Series using 12 images, MAGNUS using 8 images
            var currentPageHandle = $('[data-page-handle]').data('page-handle');
            if (currentPageHandle.includes('titan')) {
                var turntableMax = 11;
            } else if (currentPageHandle.includes('skins')) {
                var turntableMax = 3;
            } else {
                var turntableMax = 7;
            }

            // Mobile Variables
            var doubleTap = false;

            // Sort Function
            function compare(a, b) {
                if (a.order < b.order) { return -1; }
                if (a.order > b.order) { return 1; }
                return 0;
            }


            // Canvas Initialization
            $.canvasTurntable = function() {}

            // Renders each layer's image based on imgIndex
            $.canvasTurntable.imgRender = function() {
                ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas per render

                for (var i = 0; i < layers.length; i++) {
                    ctx.drawImage(
                        layers[i].img[imgIndex],
                        0, 0,
                        layers[i].img[imgIndex].width, layers[i].img[imgIndex].height,
                        (canvas.width - layers[i].img[imgIndex].width * ratio) / 2, (canvas.height - layers[i].img[imgIndex].height * ratio) / 2,
                        layers[i].img[imgIndex].width*(ratio), layers[i].img[imgIndex].height*(ratio)
                    );
                }

                // Add copyright image for Pokemon chairs
                if ((selectedSKU.toLowerCase().indexOf("charizard") > -1) || (selectedSKU.toLowerCase().indexOf("pikachu") > -1)) {
                    ctx.drawImage(pokemonLayer, 10, canvas.height - pokemonLayer.height + 5, pokemonLayer.width * .85, pokemonLayer.height * .85);
                }

                $('.canvas-loader').removeClass('active'); // Hide 'loading' overlay
            }

            // Create Layer
            $.canvasTurntable.createLayer = function(obj) {
                imgIndex = 1;
                selectedSKU = obj.data('sku').replace(/15(F|G|I)/, '15B').replace(/17(F|G|I)/, '17B');
                selectedSkuTheme = obj.data('theme');

                // For KR MAGNUS Pro - Replace MAGPAD selection with MAGNUS Pro turntable images
                if ( store_code === 'KR' && currentPageHandle === 'magnus-pro' ) {
                    selectedSKU = selectedSKU.toUpperCase().replace(/(MAG-MAT15PU|MMAT15PU)/, 'MPB2-15B').replace(/(MAG-MAT17PU|MMAT17PU)/, 'MPB2-17B');
                }

                $('.canvas-loader').addClass('active'); // Show 'loading' overlay

                if(partner_logo) {
                    partner_logo.classList.remove('logo-hidden', 'active'); // Hide partner logo if being displayed
                }

                if (selectedSKU.match(/^SK(S|R|X)/)) {
                    var selectedLayer = 'variant';
                    var selectedIsPng = false;
                    var selectedOrder = 2;
                } else if (selectedSKU.toLowerCase().indexOf("mat") > -1) {
                    // This is using the old bundle (desk/mat are separate)
                    var selectedLayer = 'variant';
                    var selectedIsPng = true;
                    var selectedOrder = 2;

                    if (obj.hasClass('atc-item-product')) {
                        selectedLayer = 'base';
                        selectedIsPng = false;
                        selectedOrder = 1;
                    }
                } else {
                    // This is using the new bundle (desk/mat are together)
                    var selectedLayer = 'base';
                    var selectedIsPng = false;
                    var selectedOrder = 1;
                }

                var layerIndex = 0;

                // Check if layer exists
                var thisLayer = $.canvasTurntable.getLayer(selectedLayer);

                // If exists, update the layer, else create a new layer
                if (thisLayer) {
                    layerIndex = layers.findIndex(function(obj) { return obj.layer === selectedLayer; });
                    layers[layerIndex].sku = selectedSKU;
                    layers[layerIndex].theme = selectedSkuTheme;
                    layers[layerIndex].png = selectedIsPng;
                    layers[layerIndex].order = selectedOrder;
                    layers[layerIndex].img = [];

                    if (obj.hasClass('atc-item-product')) {
                        imgIndex = 1; // Reset the intial view if it's the base layer being toggled
                    }
                } else {
                    layers.push({
                        layer : selectedLayer,
                        sku : selectedSKU,
                        theme : selectedSkuTheme,
                        png : selectedIsPng,
                        order : selectedOrder,
                        img : []
                    });
                }

                // Sort Layers
                layers.sort(compare);

                // Create the image objects for the layer (pre-loading)
                layerIndex = layers.findIndex(function(obj) { return obj.layer === selectedLayer; });
                for (var i = 0; i < (turntableMax + 1); i++) {
                    layers[layerIndex].img[i] = new Image();
                    layers[layerIndex].img[i].src = $.canvasTurntable.imgURL(layers[layerIndex], (i + 1));
                }

                // Load the image if it's an init, if not just render the images
                if (isInit) { $.canvasTurntable.imgInit(); isInit = false; }
                else {
                    clearTimeout(renderTimeout);
                    renderTimeout = setTimeout(function() {
                        $.canvasTurntable.imgRender();

                        // Reset partner logo image
                        partner_imgs.forEach(el => {
                            el.classList.remove('active-logo');
                            //$(el).hide();
                        });

                        displayPartnerLogo(); // Display partner logo if any
                    }, 400);
                }
            }

            // Get Layer (Uses layers global array)
            $.canvasTurntable.getLayer = function(layer) {
                return layers.find(function(obj) { return obj.layer === layer; });
            }

            // This function will set the ratios for rendering
            $.canvasTurntable.imgInit = function() {
                layers[0].img[0].onload = function() {
                    hRatio = canvas.width / layers[0].img[0].width;
                    vRatio = canvas.height / layers[0].img[0].height;
                    ratio = Math.min(hRatio, vRatio);
                    ratio = ratio + 0.03;
                    ratioScale = (canvas.width / $(container).innerWidth()) * (zoom - 1);

                    $.canvasTurntable.imgRender();
                }
            }

            $.canvasTurntable.imgURL = function (layer, index) {
                let sku = layer.sku;
                let ext = layer.png;
                const theme = layer.theme;
                if (ext) { ext = '.png'; } else { ext = '.jpg'; };
                if (index === undefined) { index = 1; };

                if (sku.match(/^SK(S|R|X)/)) {
                    if (index < 10) { index = `0${index}`; }
                    return `https://images.secretlab.co/turntable/tr:n-w_1500/${sku.replace(/^SK(S|R|X)/, 'SKR')}_${index}${ext}`;
                } else if (sku.includes('22')) {
                    if (index < 10) { index = `0${index}`; }
                    if(theme?.includes("special") || theme?.includes("esports")) {
                        sku = sku.replace(/^(S|XL)/, 'R');
                    }
                    return `https://images.secretlab.co/turntable/tr:n-w_1500/${sku}_${index}${ext}`;
                }else if (sku.includes('E24')) {
                    if (index < 10) { index = `0${index}`; }
                    sku = sku.replace(/^(M06|M08)/, 'M07').slice(0, -2) + '1R';                    
                    sku = getOldSku(sku);
                    if(theme?.includes("special") || theme?.includes("esports")) {
                        sku = sku.replace(/^(S|XL)/, 'R');
                    }                    
                    return `https://images.secretlab.co/turntable/tr:n-w_1500/${sku}_${index}${ext}`;
                } else if (Boolean(sku.match(/EL(1|3)(PU|SW)/))){
                    if (index < 10) { index = `0${index}`; }
                    sku = getEvoLiteSku(sku)
                    if(theme?.includes("special") || theme?.includes("esports")) {
                        sku = sku.replace(/^(S|XL)/, 'R');
                    }
                    return `https://images.secretlab.co/turntable/tr:n-w_1500/${sku}_${index}${ext}`;
                } else if (sku.includes('MPB2-15B-STEALTH') && index == 2) {
                    return `https://images.secretlab.co/theme/common/tr:n-w_1500/MPB2-15B-STEALTH_02_POSTER.jpg`;
                } else {
                    if (!sku.includes('NONE')) { return `https://images.secretlab.co/turntable/tr:n-w_1500/${sku}_0${index}${ext}`; }
                    else { return ''; }
                }
            }

            $.canvasTurntable.eventSpin = function(e) {
                if (isMobile) {
                    $.canvasTurntable.mobilePaging(imgIndex);
                } else {
                    var x = e.clientX;
                    var cRect = canvas.getBoundingClientRect();
                    var canvasX = Math.round(x - cRect.left);
                    imgIndex = Math.floor(canvasX / $(container).innerWidth() * (turntableMax + 1));

                    imgIndex = (turntableMax + 1) - imgIndex; // Reverse the number
                    if (imgIndex > turntableMax || imgIndex < 0) imgIndex = 0; // Loop index back to 0
                }

                if (imgIndex != currIndex) {
                    $.canvasTurntable.imgRender();

                    currIndex = imgIndex;
                }
            }

            $.canvasTurntable.eventZoom = function(e) {
                if ($canvas.hasClass('zoom')) {
                    ctx.restore();
                    $canvas.removeClass('zoom');
                    if (isMobile) { $('body').css('overflow', 'auto'); }
                    $.canvasTurntable.imgRender();
                } else {
                    ctx.save();
                    $canvas.addClass('zoom');
                    if (isMobile) { $('body').css('overflow', 'hidden'); }
                    $.canvasTurntable.eventPan(e);
                }
            }

            $.canvasTurntable.eventPan = function(e) {
                if ($canvas.hasClass('zoom')) {
                    var canvasOffset = canvas.getBoundingClientRect().top; // Get the offset to adjust the Y coordinate

                    if (isMobile) {
                        if (e.type == 'click') {
                            var x = -container.offsetWidth / 2 * ratioScale;
                            var y = -container.offsetHeight / 2 * ratioScale;
                        } else {
                            var x = -e.touches[0].clientX * ratioScale;
                            var y = -(e.touches[0].clientY - canvasOffset) * ratioScale;
                        }
                    } else {
                        var x = -e.offsetX;
                        var y = -e.offsetY;
                    }

                    ctx.setTransform(1, 0, 0, 1, x, y);
                    ctx.scale(zoom, zoom);
                    $.canvasTurntable.imgRender();
                }
            }

            // Mobile - Directional Change
            $.canvasTurntable.mobileTrigger = function(direction) {
                if (direction) { imgIndex++; }
                else { imgIndex--; }
                if (imgIndex < 0) { imgIndex = turntableMax; }
                else if (imgIndex > turntableMax) { imgIndex = 0; }
            }

            // Mobile - Paging Bullets
            $.canvasTurntable.mobilePaging = function(index) {
                if (index > turntableMax) index = 0;

                var item = $paging.find('li');
                var selected = $paging.find('li:eq('+ index +')');

                item.removeClass('active');
                selected.addClass('active');
            }

            $.canvasTurntable.resizeCanvas = function() {
                let device_pixeldensity = window.devicePixelRatio;
                $canvas.attr('width', $('#canvas-container').width() * device_pixeldensity);
                $canvas.attr('height', $('#canvas-container').height() * device_pixeldensity);

                hRatio = canvas.width / layers[0].img[0].width;
                vRatio = canvas.height / layers[0].img[0].height;
                ratio = Math.min(hRatio, vRatio);
                ratio = ratio + 0.01;
                ratioScale = (canvas.width / $(container).innerWidth()) * (zoom - 1);

                $.canvasTurntable.imgRender();
            }

            $.canvasTurntable.canvasInit = function() {
                // Get currently selected options
                var selected = $('.atc-item-variant.swap-turntable.active');
                selected.each(function(){ $.canvasTurntable.createLayer($(this)); });

                // Initalize Events
                if (isMobile) {
                    for (var i = 0; i < (turntableMax + 1); i++) { $('.canvas-turntable-paging').append('<li></li>'); }

                    $.canvasTurntable.mobilePaging(imgIndex);

                    // Set canvas dimensions for Mobile (x2)
                    canvas.width = $(container).innerWidth() * 2;
                    canvas.height = $(container).innerHeight() * 2;

                    // Zoom Button
                    $('body').on('click', '#zoom', $.canvasTurntable.eventZoom);

                    var touchStartPos, lastPos;

                    $canvas.on('touchstart', function(e) {
                        if (doubleTap) { $.canvasTurntable.eventZoom(e); }
                        if (e.type == 'touchstart') {
                            doubleTap = true;
                            setTimeout(function() { doubleTap = false; }, 200);
                        }

                        touchStartPos = Math.floor(e.targetTouches[0].pageX);
                        lastPos = 0;
                    });

                    $canvas.on('touchmove', function(e) {
                        if ($canvas.hasClass('zoom')) {
                            $.canvasTurntable.eventPan(e);
                        } else {
                            touchMovePos = Math.floor(e.targetTouches[0].pageX);
                            var touchDistance = -(touchStartPos - touchMovePos);

                            if (touchDistance % 12 === 0) {
                                if (touchDistance < lastPos) { $.canvasTurntable.mobileTrigger(false); }
                                else { $.canvasTurntable.mobileTrigger(true); }
                            }
                            lastPos = touchDistance;
                            $.canvasTurntable.eventSpin(e);
                        }
                    });
                } else {
                    // Set canvas dimensions for Desktop
                    canvas.width = $(container).innerWidth();
                    canvas.height = $(container).innerHeight();

                    // On Canvas Click
                    $canvas.on('click', $.canvasTurntable.eventZoom);

                    // On Canvas Mouse Hover
                    $canvas.on('mousemove', function(e) {
                        if (!$(this).hasClass('zoom')) {
                            $.canvasTurntable.eventSpin(e);
                        } else {
                            $.canvasTurntable.eventPan(e);
                        }
                    });
                }

                // Interval checking to ensure the canvas is the correct size after init, if not force a resize to correct it.
                var loopCheckCanvas = setInterval(function() {
                    if (loopCheck) {
                        var currWidth = $(container).innerWidth();
                        var currHeight = $(container).innerWidth();
                        var canvasWidth = canvas.width;
                        var canvasHeight = canvas.height;

                        if ((currWidth != canvasWidth) || (currHeight != canvasHeight)) {
                            canvas.width = currWidth;
                            canvas.height = currHeight;
                            $.canvasTurntable.resizeCanvas();
                            loopCheck = false;
                        } else {
                            loopCheck = false;
                        }
                    } else {
                        clearInterval(loopCheckCanvas);
                    }
                }, 1000);
            }

            // Update the canvas and re-render the image on resize
            $(window).on('resize', $.canvasTurntable.resizeCanvas);
        }

        // on updateATC
        whenAvailable('secretlabATC', function() {
            if (container != undefined) {
                $.canvasTurntable.canvasInit();
                if (!isMobile) { setTimeout(function(){ $('#canvasTurntable').click().click(); }, 200); }
            }

            // Display Partner logo if any
            if ($('#partnerLogo').length > 0) { displayPartnerLogo(); }

            $(window).on('updateATC', function(currentEvent, eventType, originalEvent) {
                if (originalEvent.currentTarget.tagName == 'BUTTON') {
                    $.productDisplay.updateProductDisplay();

                    var target = $(originalEvent.currentTarget);
                    if (target.attr('data-sku') == undefined) {
                        target = target.parents('[data-atc-id]');
                    }

                    if ($canvas != undefined && target.hasClass('swap-swatch')) {
                        // Reset the zoom if currently zoomed in
                        if ($canvas.hasClass('zoom')) { $.canvasTurntable.eventZoom(); }

                        // Create/Update layer
                        $.canvasTurntable.createLayer($(originalEvent.currentTarget));
                    }
                }
            });

            function switchAccessoryVideo(attr) {
                let sku = $(attr).data('sku');
                $('.accessory-video').removeClass('d-lg-block');
                $('.accessory-video-m').addClass('d-none');
                $(`.accessory-video[data-sku="${sku}"]`).addClass('d-lg-block');
                $(`.accessory-video-m[data-sku="${sku}"]`).removeClass('d-none');
            }
            if($('.atc-item-btn[data-type="Accessory"].active').length) {
                let activeVariant = $('.atc-item-btn[data-type="Accessory"].active');
                switchAccessoryVideo(activeVariant);
            }
            $('body').on('click', '.atc-item-btn[data-type="Accessory"]', function(){
                switchAccessoryVideo(this);
            });


            if ($('.product-display-video').length) {
                // Update Video
                function switchVideo() {
                    var getSKU = $('[data-atc-id]').attr('data-sku');
                    $('.product-display-video, [data-product-video]').hide();
                    $('.video-button').removeClass('active s-pu r-pu xl-pu s-sw r-sw xl-sw');

                    const skuRegex = /(S22|R22|XL22)(PU|Napa|SU|AL|SW)/;
                    const matches = getSKU.match(skuRegex);

                    if (matches) {
                        const [prefix, suffix] = matches.slice(1);
                        const video = prefix + (suffix === 'SW' ? suffix : 'PU'); // considering that at the current moment the only other permutation is SW
                        const className = prefix.toLowerCase().slice(0, -2) + (suffix === 'SW' ? '-sw' : '-pu');
                        $(`[data-product-video=${video}]`).show();
                        $('.video-button').addClass(className);
                    }
                }
                function switchVideoEvoLite() {
                    var getSKU = $('[data-atc-id]').attr('data-sku');
                    $('.product-display-video, [data-product-video]').hide();
                    $('.video-button').removeClass('active');
                    let video = "REL";
                    if(Boolean(getSKU.match(/XEL(1|3)(PU|SW)/))){
                        video = "XEL";
                    }
                    $(`[data-product-video=${video}]`).show();
                }
                var currentPageHandle = $('[data-page-handle]').data('page-handle');
                if(currentPageHandle == 'titan-evo-lite'){
                    switchVideoEvoLite()
                    $('body').on('click', '.atc-item-btn', switchVideoEvoLite);
                }else {
                    switchVideo();
                    $('body').on('click', '.atc-item-btn', switchVideo);
                }

                $('body').on('click', '.video-button', function() {
                    if ($(this).hasClass('active')) {
                        $('.video-button').removeClass('active');
                        $('.product-display-video').fadeOut();
                    } else {
                        $('.video-button').addClass('active');
                        $('.product-display-video').fadeIn();
                    }
                });
            }
        });
    });

    window.product_display = [];
});
});

function generateSubimages(container) { $.productDisplay.generateSubimages(container); }
function updateProductDisplay(container) { $.productDisplay.updateProductDisplay(container); }
